import { Component, Input } from '@angular/core';

@Component({
  selector: 'sky-mobile-info',
  templateUrl: './mobile-info.component.html',
  styleUrls: ['./mobile-info.component.scss'],
})
export class MobileInfoComponent {
  @Input() brand: string | undefined = undefined;
  @Input() phoneModel: string | undefined = undefined;
  @Input() imei: string | undefined = undefined;
}
